import React from 'react'
import ScrollToTop from '../utils/ScrollToTop.jsx'
import LandingContainer from '../containers/LandingContainer.jsx'
import ServicesGridContainer from '../containers/ServicesGridContainer.jsx'
import HandKeyContainer from '../containers/HandKeyContainer.jsx'
import PoolInfoContainer from '../containers/PoolInfoContainer.jsx'
import SmallReferencesContainer from '../containers/SmallReferencesContainer.jsx'
import GoogleMapContainer from '../containers/GoogleMapContainer.jsx'
import FooterBtnContainer from '../containers/FooterBtnContainer.jsx'

const Landing = () => (
    <div>
        <ScrollToTop />
        <LandingContainer />
        <div id="services-id" className="section-body">
            <ServicesGridContainer />
            <HandKeyContainer />
            <PoolInfoContainer />
            <SmallReferencesContainer />
            <GoogleMapContainer />
        </div>
        <FooterBtnContainer />
    </div>
)

export default Landing



// WEBPACK FOOTER //
// ./src/scripts/routes/Landing.jsx